import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { CardId, TaskWithCard } from '@voll-intelligence/domain';

import { queryKeys } from '@web/core/query';
import { boardRepository } from '@web/data/repositories';
import { useOrgContext } from '@web/ui/core';

export interface UseCardTasksResult {
  query: UseQueryResult<readonly TaskWithCard[]>;
  tasks: readonly TaskWithCard[];
}

/**
 * Tasks attached to a card. Reads the dedicated `GET /cards/:id/tasks`
 * endpoint. Shared by the drawer Tasks tab and the task detail drawer —
 * deduped by `queryKeys.cards.tasks`.
 */
export function useCardTasks(cardId: CardId): UseCardTasksResult {
  const { orgId } = useOrgContext();

  const query = useQuery({
    queryKey: queryKeys.cards.tasks(orgId, cardId),
    queryFn: () => boardRepository.loadCardTasks(orgId, cardId),
    enabled: Boolean(cardId),
  });

  return { query, tasks: query.data ?? [] };
}
